import { useFavicon } from "@vueuse/core";

export function setupFavicon() {
  const { hostname } = window.location;

  if (hostname === "localhost") {
    useFavicon("/img/obiado-green.svg");
  } else if (hostname === "demo.obiado.pl") {
    useFavicon("/img/obiado-blue.svg");
  }
}
